import { styled, Typography, Button } from '@mui/material';
import PatternBG from 'assets/images/graphic-zizzi-pattern.jpg';
import WhiteWave from 'assets/images/graphic-wave-white.svg';
import { theme } from 'assets/themes/zizzi';
import Slider from 'components/Slider';
import TertiaryButton from 'components/TertiaryButton';

const pageBgColor = theme.palette.white;
const headerColor = theme.palette.primary.main;
const footerHeight = '144px';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: ${footerHeight};

  ${theme.breakpoints.up('sm')} {
    border-radius: ${theme.radius.lg};
    overflow: hidden;
    height: auto;
    padding-bottom: 0;
  }
`;

export const Header = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 52px;
  background: ${headerColor};
`;

export const Slides = styled(Slider)`
  height: 100%;

  > div {
    height: 100%;
  }
`;
export const Slide = styled('div')`
  background-image: url(${PatternBG});
  background-size: contain;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled('div')`
  background: url(${WhiteWave}) center bottom -1px no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 250px;
  padding: 1rem 1.5rem 3rem;

  ${theme.breakpoints.up('sm')} {
    min-height: 280px;
  }
`;

export const Title = styled(Typography)`
  color: ${pageBgColor};
  font-size: 30px;
  margin-bottom: 0;
`;

export const SubTitle = styled(Typography)`
  color: ${pageBgColor};
  font-size: 20px;
  margin-top: 1.5rem;
`;

export const OnboardingContent = styled('div')`
  flex: 1;
  padding: 1rem;
  display: flex;
  align-items: center;
  background: ${pageBgColor};
`;

export const StyledButton = styled(Button)`
  ${theme.breakpoints.up('sm')} {
    max-width: 350px;
  }
`;

export const PageNumber = styled(Typography)`
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 1rem;
`;

export const HeaderButton = styled(TertiaryButton)`
  color: ${pageBgColor};
`;

export const Footer = styled('div')`
  align-items: center;
  background: ${pageBgColor};
  border-radius: 12px 12px 0px 0px;
  bottom: 0;
  box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px;
  position: fixed;
  width: 100%;

  ${theme.breakpoints.up('sm')} {
    position: relative;
  }
`;
